import { useMediaQuery, Table, Thead, Tbody, Tr, Th, Td, Box, Stack, Text, Badge } from '@chakra-ui/react';

const ResponsiveTable = ({ headers, data }) => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {!isMobile ? (
        // Desktop version (standard table layout)
        <Table variant="simple">
          <Thead>
            <Tr>
              {headers.map((header, index) => (
                <Th key={index} textTransform="none">{header.label}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              {headers.map((header, index) => (
                <Td key={index} fontSize="sm" color="gray.500">
                  {header.render ? header.render(data) : header.accessor(data) || 'N/A'}
                </Td>
              ))}
            </Tr>
          </Tbody>
        </Table>
      ) : (
        // Mobile version (stacked headers and content)
        <Box>
          <Stack spacing={4}>
            {headers.map((header, index) => (
              <Box key={index}>
                <Text fontSize="sm" color="gray.500" fontWeight="bold">{header.label}:</Text>
                <Text fontSize="sm" color="gray.500">
                  {header.render ? header.render(data) : header.accessor(data) || 'N/A'}
                </Text>
              </Box>
            ))}
          </Stack>
        </Box>
      )}
    </>
  );
};

export default ResponsiveTable;
